import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationBarProps {
  page: number
  perPage: number
  total: number
  lastPage: number
  onPageChange: (page: number) => void
  onPerPageChange: (perPage: number) => void
  perPageOptions?: number[]
}

export default function PaginationBar({ page, perPage, total, lastPage, onPageChange, onPerPageChange, perPageOptions = [10, 25, 50, 100] }: PaginationBarProps) {
  if (total === 0) return null

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-gray-100">
      <div className="flex items-center gap-2">
        <span className="text-xs sm:text-sm text-gray-500">Exibir</span>
        <select
          value={perPage}
          onChange={e => onPerPageChange(Number(e.target.value))}
          className="h-8 rounded-md border border-gray-200 text-xs sm:text-sm text-gray-600 px-2 focus:border-brand-300 focus:ring-1 focus:ring-brand-500/10 outline-none"
        >
          {perPageOptions.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span className="text-xs sm:text-sm text-gray-500">de <strong className="text-gray-700">{total.toLocaleString('pt-BR')}</strong></span>
      </div>
      <div className="flex items-center gap-2">
        <span className="hidden sm:inline text-sm text-gray-400">
          {((page - 1) * perPage) + 1}–{Math.min(page * perPage, total)} de {total.toLocaleString('pt-BR')}
        </span>
        <div className="flex items-center gap-1">
          <PageBtn onClick={() => onPageChange(1)} disabled={page <= 1}>
            <ChevronLeft className="w-4 h-4" /><ChevronLeft className="w-4 h-4 -ml-2.5" />
          </PageBtn>
          <PageBtn onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
            <ChevronLeft className="w-4 h-4" />
          </PageBtn>
          <span className="px-2 text-xs text-gray-500 sm:hidden">{page}/{lastPage}</span>
          <PageBtn onClick={() => onPageChange(page + 1)} disabled={page >= lastPage}>
            <ChevronRight className="w-4 h-4" />
          </PageBtn>
          <PageBtn onClick={() => onPageChange(lastPage)} disabled={page >= lastPage}>
            <ChevronRight className="w-4 h-4" /><ChevronRight className="w-4 h-4 -ml-2.5" />
          </PageBtn>
        </div>
      </div>
    </div>
  )
}

function PageBtn({ children, onClick, disabled }: { children: React.ReactNode; onClick: () => void; disabled: boolean }) {
  return (
    <button onClick={onClick} disabled={disabled} className="h-9 w-9 sm:h-8 sm:w-8 flex items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
      {children}
    </button>
  )
}
